export const InstallAppBaseComponents = (game, components) => {
  // console.log('[Installing Components]');

  const installedComponents = [];
  const installComponent = (global, key, component, data) => {
    if (global) {
      const installed = game.plugins.install(key, component, true, null, data);
      if (installed) {
        game[key] = installed;
        // console.log('\t installed : ' + key);
        installedComponents.push(installed);
      }
    } else {
      game.plugins.installScenePlugin(key, component, key);
    }
  };

  // install the components
  Object.keys(components).forEach((key) => {
    if (components[key].prototype instanceof Phaser.Plugins.BasePlugin) {
      const global = components[key].prototype instanceof Phaser.Plugins.ScenePlugin != true;
      installComponent(global, key, components[key]);
    } else {
      const { component, data } = components[key];
      if (component && component.prototype instanceof Phaser.Plugins.BasePlugin) {
        const global = component.prototype instanceof Phaser.Plugins.ScenePlugin != true;
        installComponent(global, key, component, data);
      } else console.error('Component is not a Phaser plugin : ' + key);
    }
  });

  game.events.once(Phaser.Core.Events.READY, () => {
    // run start - all components shuld be installed and ready to use
    installedComponents.forEach((c) => (c.onGameReady ? c.onGameReady() : null));
  });
};
